import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { fetchProductionStats } from '../../api/dashboard';
interface Props {
  activeRegion: string;
}
const StatusPanel: React.FC<Props> = ({ activeRegion }) => {
  const isChengde = activeRegion === 'Chengde';
  const highlightColor = isChengde ? '#ff9800' : '#00e5ff';
  const [chartData, setChartData] = useState<{
    years: string[];
    regions: string[];
    data: { [year: string]: number[] };
  }>({
    years: [], regions: [], data: {}
  });
  useEffect(() => {
    fetchProductionStats().then(setChartData).catch(console.error);
  }, []);
  const option = {
    baseOption: {
      timeline: {
        axisType: 'category',
        autoPlay: true,
        playInterval: 2000,
        data: chartData?.years || [],
        lineStyle: { color: highlightColor },
        controlStyle: { itemSize: 20, color: highlightColor, borderColor: highlightColor }
      },
      backgroundColor: 'transparent',
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(11, 17, 32, 0.9)',
        borderColor: '#00e5ff',
        textStyle: { color: '#fff' },
        axisPointer: { type: 'shadow' }
      },
      grid: { left: '15%', right: '15%', top: '20%', bottom: '20%' },
      xAxis: {
        type: 'value',
        axisLine: { show: false },
        splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } },
        axisLabel: { color: '#fff' }
      },
      yAxis: {
        type: 'category',
        data: chartData?.regions || [],
        axisLine: { lineStyle: { color: '#03a9f4' } },
        axisLabel: { color: '#fff' }
      },
      series: [
        {
          name: '产量(万吨)',
          type: 'bar',
          itemStyle: {
            color: (params: any) => {
              const name = params.name;
              const regionMap: { [key: string]: string } = { 'Chengde': '承德', 'Panzhihua': '攀枝花', 'Shanghai': '上海', 'Hunan': '湖南' };
              const targetName = regionMap[activeRegion];
              const isActive = (name === targetName);
              if (isActive) {
                return {
                  type: 'linear', x: 0, y: 0, x2: 1, y2: 0,
                  colorStops: [{ offset: 0, color: '#ff9800' }, { offset: 1, color: '#ffc107' }] // Orange highlight
                };
              }
              return {
                type: 'linear', x: 0, y: 0, x2: 1, y2: 0,
                colorStops: [{ offset: 0, color: '#004d40' }, { offset: 1, color: '#00e5ff' }] // Default Blue
              };
            },
            borderRadius: [0, 4, 4, 0]
          },
          label: {
            show: true,
            position: 'right',
            color: '#fff',
            formatter: '{c}万'
          }
        }
      ]
    },
    options: (chartData?.years || []).map(year => ({
      title: { text: `${year}年全球钒产量`, textStyle: { color: '#fff' } },
      series: [{ data: chartData.data?.[year] || [] }]
    }))
  };
  return (
    <div className="hud-panel left-panel">
      <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />
    </div>
  );
};
export default StatusPanel;
